import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import MouseAndKeyboardCloseHandler from '../../../Common/MouseAndKeyboardCloseHandler';
import Help from '../../../Common/Help';
import Button from '../../../Common/Button';
import Utils from '../../../../Services/Utils';
import ConfigService from '../../../../Services/api/Config';
import ChargeCodes from '../../../../Services/api/ChargeCodes';
import { checkTriggerCondition } from '../../../../Services/ConditionalService';
import TextArea from '../../../FormFields/TextArea';

import InputCurrencyCharge from '../../../FormFields/Currency/currencyCharge';

import LfaContext from '../../../../Context/LfaContext';

import './style.scss';

import WrapperWidgetIcon, { ATTACHMENT_ICON, CLONE_ICON, CONDITION_ICON, EDIT_ICON, NOTE_ICON, SCORE_ICON, TRIGGER_ICON } from '../WrapperWidgetIcon';

class WrapperWidget extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      showDialog: false,
      workOrderTrigger: 0,
      workOrderRequired: false,
      triggersCharges: [],
    };
  }

  componentDidMount = async () => {
    await this.getTriggerChargeCodeData();
  };

  componentDidUpdate = async (prevProps, prevState) => {
    const { value, setLocaleValuesonDefaultParameters, field } = this.props;
    if (!Utils.equals(prevProps.value, value)) {
      await this.getTriggerChargeCodeData();
    }
    if (prevState.showDialog !== this.state.showDialog && (field.created_in_language || field.updated_in_language)) {
         if(this.state.showDialog){
            setLocaleValuesonDefaultParameters();
         }
    }
  };

  getDomElement = () => this.$el;

  actionAndClose = async (fn) => {
    const preventClose = fn();
    if (!preventClose) {
      this.setState({ showDialog: false });
      return;
    }
    const result = await preventClose;
    if (result) {
      this.setState({ showDialog: false });
    }
  };

  renderTriggerNumber = (amountTriggers, error) => {
    return (
      <span className="IconNumber" style={{ backgroundColor: ConfigService.getColor(error ? 'errorColor' : 'secondaryColor') }}>
        {amountTriggers}
      </span>
    );
  };

  onClickWorkOrder = () => {
    const { field, data, handleClickWorkOrder } = this.props;
    handleClickWorkOrder(field, data);
  };

  renderLetterTrigger = (letter, amountTriggers, error) => {
    const workOrderTrigger = letter !== 'T';
    if (amountTriggers === 0 && !workOrderTrigger) {
      return null;
    }

    const hasWorkOrderTriggerSaved = workOrderTrigger && amountTriggers > 0;
    return (
      <span className="IconBlue sample" style={{ backgroundColor: ConfigService.getColor('secondaryColor') }}>
        {letter}
        {hasWorkOrderTriggerSaved && this.renderTriggerNumber(amountTriggers, error)}
      </span>
    );
  };

  isTriggerWorkOrderLaunch = () => {
    const { field, data } = this.props;
    const { workOrderRequired } = this.state;
    if (!data) {
      return false;
    }
    const { value } = data;
    const { triggers } = field;
    let total = 0;
    let wORequired = false;
    
    if (triggers) {
      triggers.map((trigger) => {
        const { triggerType } = trigger;
        const result = checkTriggerCondition(trigger, field, value);
        if (result && triggerType === '2') {
          total++;
          if (trigger.workOrderRequired) {
            wORequired = true;
          }
        }
      });
    }
    if (wORequired !== workOrderRequired) {
      this.setState({
        workOrderRequired: wORequired
      });
    }
    return total > 0 
  };

  isTriggerLaunch = () => {
    const { field, data, showTriggerConditionMet } = this.props;
    if (!data) {
      return '';
    }
    const { value, workOrderTriggers } = data;
    const { triggers } = field;
    const resultObj = {
      workOrder: [],
      total: 0
    };
    let workOrderTotal = 0;
    let error = false;

    if (triggers) {
      triggers.map((trigger) => {
        const { triggerType, id } = trigger;
        const result = checkTriggerCondition(trigger, field, value);
        if (result) {
          resultObj.total++;
          if (triggerType === '2') {
            resultObj.workOrder.push(id);
            if (workOrderTriggers && workOrderTriggers[id]) {
              error = !error ? !Utils.isNull(workOrderTriggers[id].work_orders.find((item) => !item.valid)) : error;
              workOrderTotal += workOrderTriggers[id].work_orders.length;
            }
          }
        }
      });
    }
    return resultObj.total === 0 ? null : (
      <>
        {showTriggerConditionMet && this.renderLetterTrigger('T')}
        {resultObj.workOrder.length > 0 && this.renderLetterTrigger('W', workOrderTotal, error, resultObj.workOrder)}
      </>
    );
  };

  handleChangeChargeCode = async (value, trigger) => {
    await this.updateDFChargeCode(trigger,'default_amount', value);
  };

  handleCommentChargeCode = async (v, trigger) => {
    await this.updateDFChargeCode(trigger, 'comment', v);
  };

  updateDFChargeCode = async (triggerId, chargeValue, value) => {
    const { onChangeTrigger } = this.props;
    const { triggersCharges } = this.state;
    let change = false;
    const triggersChargesChange = triggersCharges.map((item) => {
      if (item['id'] === triggerId) {
        if (!Utils.equals(item.chargeCode[chargeValue], value)) {
          change = true;
          item.chargeCode = { ...item.chargeCode };
          item.chargeCode[chargeValue] = value;
        }
      }
      return item;
    });
    if (change) {
      onChangeTrigger(triggersChargesChange);
      this.setState({
        triggersCharges: triggersChargesChange
      });
    }
  };

  getTriggerChargeCodeData = async () => {
    const { field, data, onChangeTrigger } = this.props;
    const { triggersCharges } = this.state;
    const property = this.context ? this.context.property : null;
    if (!data) {
      return '';
    }

    const { value } = data;
    const { triggers } = field;
    const chargesId = [];
    let triggersActive = [];
    let triggersActiveAux = [];
      if (triggers) {
      triggers.map((trigger) => {
        const { triggerType, charge_code_id } = trigger;
        const result = checkTriggerCondition(trigger, field, value);
        if (result && triggerType === '3') {
          chargesId.push(charge_code_id);
          triggersActiveAux.push(trigger);
        }
      });

      if (chargesId.length > 0) {
        const chargeCodeList = await ChargeCodes.list({ id: chargesId.join(','), pms_platform: property.pms_platform?.id });
        triggersActiveAux.forEach((trigger) => {
          const chargeCodeData = chargeCodeList.filter((c) => c.id === trigger.charge_code_id);
          if (chargeCodeData.length > 0) {
            let chargeCode = { ...chargeCodeData[0] };
            const active = triggersCharges.filter((item) => item.id === trigger.id);
            if (active.length > 0 && active[0].chargeCode) {
              chargeCode = active[0].chargeCode;
            } else {
              const { property_default_amounts, default_amount } = chargeCode;
              if (!Utils.isEmpty(property) && !Utils.isEmpty(property_default_amounts)) {
                if (!Utils.isNull(property_default_amounts[property.id])) {
                  chargeCode['default_amount'] = property_default_amounts[property.id];
                }
                else {
                  chargeCode['default_amount'] = default_amount;
                }
              }
              else {
                chargeCode['default_amount'] = default_amount;
              }
              if (!Utils.isEmpty(data.chargesTriggers)) {
                const selectedTrigger = data.chargesTriggers.filter((item) => item.id === trigger.id);
                if (!Utils.isEmpty(selectedTrigger)) {
                  chargeCode.default_amount = !Utils.isNull(selectedTrigger[0].amount) ? selectedTrigger[0].amount : chargeCode['default_amount'];
                  chargeCode.amount = selectedTrigger[0].amount;
                  chargeCode.comment = selectedTrigger[0].comment;
                }
              }
            }
            trigger.chargeCode = chargeCode;
            triggersActive.push(trigger);
          }
        });
      }
    }
    if (!Utils.equals(triggersCharges, triggersActive)) {
      onChangeTrigger(triggersActive);
      this.setState({
        triggersCharges: triggersActive
      });
    }
  };

  renderChargeCodeTriggers = () => {
    const { onErrorTrigger, errorTrigger, field } = this.props;
    const { triggersCharges } = this.state;
    const { property } = this.context;
    return (
      <div className="WrapperWidget_Footer">
        <div className="Widget_Label">Repair Cost:</div>
        {triggersCharges.map((trigger) => {
          const { chargeCode } = trigger;
          return (
            <div className="WrapperWidget_Charge" key={trigger.id} style={{ borderColor: ConfigService.getColor('tertiaryColor') }}>
              {this.renderLetterTrigger('T')}
              <div className="WrapperWidget_Charge_Line">
                <div className="Widget_Label WrapperWidget_Charge_Label">{chargeCode.description}</div>
                <InputCurrencyCharge
                  className="WrapperWidget_Charge_Input"
                  value={chargeCode.default_amount}
                  symbol={property?.currency_code}
                  required={true}
                  onError={onErrorTrigger}
                  error={errorTrigger}
                  disabled={field.disabled}
                  onChange={(v) => this.handleChangeChargeCode(v, trigger.id)}
                />
              </div>
              <div className="WrapperWidget_Charge_Line">
                <TextArea
                  className="WrapperWidget_Charge_Comment"
                  value={chargeCode.comment}
                  label="Charge comment"
                  onChange={(v) => this.handleCommentChargeCode(v, trigger.id)}
                  disabled={field.disabled}
                />
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  renderButton = (text, fn, className = '', display = true) => {
    return <Button display={display} className={`Button_Small ${className}`} onClick={() => this.actionAndClose(fn)} btnText={text} />;
  };

  render() {
    const {
      children,
      handleSubmit,
      handleDelete,
      handleCancel,
      handleClone,
      renderForm,
      formTitle,
      field,
      data,
      isDisabled,
      headerHidden,
      isCompact,
      preventDelete,
      descriptionAsIcon,
      handleClickNote,
      handleClickAttachment,
      className,
      api
    } = this.props;
    const { showDialog, workOrderRequired, triggersCharges } = this.state;
    const label =  api ?  api.getFieldsVerbiage(field, 'label') : field.label;
    const description = api ?  api.getFieldsVerbiage(field, 'description') : field.description;

    return (
      <div className={classNames('WrapperWidget', className, { WrapperWidget_Compact: isCompact })}>
        <div
          className={classNames('WrapperWidget_Widget', {
            ShowDialog: showDialog,
            WrapperWidget_Editable: !isDisabled
          })}>
          {field && (
            <>
              {!headerHidden && (
                <div className={classNames('WrapperWidget_Header', { Inline: field.labelInline && isDisabled })}>
                  {label && (
                    <div
                      className={classNames('Widget_Label Table', {
                        Widget_Label_Icon: Boolean(descriptionAsIcon) && !Utils.isNull(field.description)
                      })}>
                      <div className="Widget_Label_Text Inline">
                        {label}
                        {field.required && (
                          <span className="Widget_Label-Required" style={{ color: ConfigService.getColor('errorColor') }}>
                            *
                          </span>
                        )}
                      </div>

                      {descriptionAsIcon && field.description && (
                        <Help message={field.description} className="Tooltip_Black" classParent="Grey Small">
                          i
                        </Help>
                      )}
                    </div>
                  )}
                  <div className={classNames('WrapperDescription')}>
                    <div className="Widget_Description" style={{ color: ConfigService.getColor('tertiaryColor') }}>
                      {!descriptionAsIcon && <div className='Widget_Description_Des'>{description}</div>}
                    </div>
                    <div className="Widget_Description_Icons">
                      {this.isTriggerLaunch()}

                      <WrapperWidgetIcon display={field.conditions && field.conditions.length > 0 && !isDisabled} type={CONDITION_ICON} />

                      <WrapperWidgetIcon display={field.triggers && field.triggers.length > 0 && !isDisabled} type={TRIGGER_ICON} />

                      <WrapperWidgetIcon display={field.scoreType && field.scoreType.value > 0 && !isDisabled} type={SCORE_ICON} />

                      <WrapperWidgetIcon display={field.photo && !isDisabled} type={ATTACHMENT_ICON} />

                      <WrapperWidgetIcon display={field.notes && !isDisabled} type={NOTE_ICON} />
                    </div>
                  </div>
                </div>
              )}
              <div
                className={classNames('WrapperWidget_Content', {
                  Inline: field && field.labelInline && isDisabled,
                  WrapperWidget_Content_Icons: (field.photo || field.notes) && isDisabled
                })}>
                {children}
              </div>
              {!isDisabled && (
                <>
                  <div className="WrapperWidget_Content_Edit Pointer" onClick={() => this.setState({ showDialog: !showDialog })}>
                    <WrapperWidgetIcon display type={EDIT_ICON} />
                  </div>
                  <div onClick={handleClone} className="WrapperWidget_Content_Clone Pointer">
                    <WrapperWidgetIcon display type={CLONE_ICON} />
                  </div>
                </>
              )}
              {isDisabled && (field.photo || field.notes) && (
                <div className="Widget_Description_Icons Widget_Description_Icons_Hover Align_Right">
                  <div className="Widget_Description_Icons_Hover_Wrapper">
                    <>
                      <WrapperWidgetIcon
                        onClick={handleClickAttachment}
                        display={field.photo}
                        type={ATTACHMENT_ICON}
                        iconNumber={data && data.photo && data.photo.length > 0 ? data.photo.length : 0}
                      />

                      <WrapperWidgetIcon
                        color={'auxColor'}
                        onClick={handleClickNote}
                        display={field.notes}
                        type={NOTE_ICON}
                        iconNumber={data && data.notes ? 1 : 0}
                      />
                    </>
                  </div>
                </div>
              )}
              {this.isTriggerWorkOrderLaunch() && (
                <div className="WrapperWidget_Footer">
                  <Button className="Button_Small" onClick={this.onClickWorkOrder} btnText={'Create Work Order'} />
                  {workOrderRequired && (
                    <span className="InputWrapper-Label-Required" style={{ color: ConfigService.getColor('errorColor') }}>
                      *
                    </span>
                  )}
                </div>
              )}
              {triggersCharges.length > 0 && this.renderChargeCodeTriggers()}
            </>
          )}
        </div>
        {showDialog && (
          <div ref={(el) => (this.$el = el)}>
            <MouseAndKeyboardCloseHandler getDomElement={this.getDomElement} onClickOutside={() => this.actionAndClose(handleCancel)}>
              <div className={`${(field && field.updated_in_language) ? "WrapperWidget_Form top-50" : "WrapperWidget_Form"}`}>
                <div className="WrapperWidget_Form_Title" style={{ backgroundColor: ConfigService.getColor('tertiaryColor', 0.2) }}>
                  {formTitle}
                </div>
                <div className="WrapperWidget_Form_Content">{renderForm()}</div>
                <div className="WrapperWidget_Form_Footer Center">
                  {this.renderButton('Save', handleSubmit)}
                  {this.renderButton('Cancel', handleCancel, 'Button_Cancel')}
                  {this.renderButton('Delete', handleDelete, 'Button_Delete', !preventDelete)}
                </div>
              </div>
            </MouseAndKeyboardCloseHandler>
          </div>
        )}
      </div>
    );
  }
}

WrapperWidget.contextType = LfaContext;

WrapperWidget.propTypes = {
  children: PropTypes.node,
  field: PropTypes.object,
  data: PropTypes.object,
  className: PropTypes.string,
  handleSubmit: PropTypes.func,
  handleDelete: PropTypes.func,
  handleCancel: PropTypes.func,
  handleClone: PropTypes.func,
  renderForm: PropTypes.func,
  formTitle: PropTypes.string,
  isCompact: PropTypes.bool,
  isDisabled: PropTypes.bool,
  headerHidden: PropTypes.bool,
  preventDelete: PropTypes.bool,
  descriptionAsIcon: PropTypes.bool,
  showTriggerConditionMet: PropTypes.bool
};

export default WrapperWidget;
